import React, { FC, ReactElement, useCallback, useMemo } from 'react';
import {
  InfoIcon,
  MenuItem,
  SelectChangeEvent,
  Tooltip,
  useTheme,
} from '@cherre-frontend/ui';
import { TopBarSelectProps } from './model';
import { ListItemContentContainer, StyledSelect } from './styles';

const TopBarSelect: FC<TopBarSelectProps> = ({
  options = [],
  onChange,
  tooltipText,
  value,
  borderColor,
  fontColor,
  label = 'Mode',
  variant = 'outlined',
  width = '220px',
  tooltipIcon = (
    <InfoIcon
      sx={{
        marginRight: '15px',
        color: 'white !important',
      }}
    />
  ),
}): ReactElement => {
  const theme = useTheme();
  const handleOnChange = useCallback(
    (e: SelectChangeEvent<unknown>) => {
      onChange(e.target.value as string | number);
    },
    [onChange]
  );

  const ToolTipElement = useMemo(() => {
    if (!tooltipText) {
      return undefined;
    }

    return <Tooltip title={tooltipText}>{tooltipIcon}</Tooltip>;
  }, [tooltipText, tooltipIcon]);

  return (
    <StyledSelect
      borderColor={borderColor || theme.palette.primary.light}
      fontColor={fontColor || theme.palette.grey['100']}
      width={width}
      value={value}
      size='small'
      color='primary'
      onChange={handleOnChange}
      endAdornment={ToolTipElement}
      variant={variant}
      label={label}
      notched
    >
      {options.map((option) => (
        <MenuItem
          key={option.id}
          value={option.value}
          disabled={option.disabled}
        >
          <ListItemContentContainer>
            <span>{option.label}</span>
            {option.extraContent && <span>{option.extraContent}</span>}
          </ListItemContentContainer>
        </MenuItem>
      ))}
    </StyledSelect>
  );
};

export default TopBarSelect;
